<template>
    <router-link :to="item.link" class="t-lk-photos-item">
        <img v-if="item.img" class="t-lk-photos-item__img" :src="item.img" :alt="item.name">
        <div class="t-lk-photos-item__content">
            <div class="t-lk-photos-item__name">{{ item.name }}</div>
            <div class="t-lk-photos-item__date">{{ item.date }}</div>
        </div>
    </router-link>
</template>

<script>
    export default {
        name: "lk-photos-item",
        props: {
            item: Object,
        },
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/lk/lk-photos-item/lk-photos-item.vue